import axios from 'axios'
import { MutateRequest } from '../request-type'
import DeclarationApi from '../apiConfig'
import { EditTransitOperationAuditRequest } from '../../../../../api/models/edit-transit-operation-audit-request'
import { EditTransitOperationAuditResponse } from '../../../../../api/models/edit-transit-operation-audit-response'

const { baseUrl } = DeclarationApi.paths.transitOperationAudit

async function putTransitOperationAudit({
  id,
  data,
}: MutateRequest<EditTransitOperationAuditRequest>) {
  return (await axios.put<EditTransitOperationAuditResponse>(`${baseUrl}/${id}`, data)).data
}

export default putTransitOperationAudit
